(() => {
  const form = document.getElementById('OumaAutomaticLocale');
  if (!form || window.Shopify?.designMode) return;
  const current = document.documentElement.lang.split('-')[0];
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 4500);
  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {credentials:'same-origin', signal:controller.signal})
    .then(r => {if (!r.ok) throw Error('localization'); return r.json();})
    .then(data => {
      const country = data.detected_values?.country?.handle;
      if (!country || !/^[A-Z]{2}$/.test(country)) return;
      const language = country === 'DK' ? 'da' : 'en';
      const key = 'ouma-location-language:' + country;
      if (current === language) {try {sessionStorage.setItem(key, language);} catch {} return;}
      try {if (sessionStorage.getItem(key) === language) return; sessionStorage.setItem(key, language);} catch {}
      form.querySelector('[name="language_code"]').value = language;
      form.submit();
    }).catch(() => {}).finally(() => clearTimeout(timer));
})();
